export default __webpack_public_path__ + "static/media/coming-soon-bg.ddab5ef6.jpg";